import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const reviews = [
  { name: "Marisol R.", event: "Backyard 7th Birthday", text: "The Splash Combo was the hit of the summer. Delivered early, spotless, and picked up without me lifting a finger. Booking online took two minutes." },
  { name: "Devon & Kayla", event: "Garden Wedding", text: "The draped tent turned our backyard into a venue. The team was professional and the deposit process was so easy. Absolutely booking again." },
  { name: "Coach Tim", event: "Little League Fundraiser", text: "Tables, chairs, and a popcorn cart for 200 people. Everything showed up on time and the kids went wild. Lifesavers." },
];

export default function Testimonials() {
  return (
    <section id="reviews" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-14">
          <h2 className="font-display font-900 tracking-tight text-4xl md:text-6xl leading-none max-w-xl">
            Parties we've <span className="text-brand-blue">pulled off.</span>
          </h2>
          <div className="flex items-center gap-2">
            <div className="flex text-brand-coral">
              {[...Array(5)].map((_, i) => <Star key={i} size={18} fill="currentColor" />)}
            </div>
            <span className="font-700">4.9 / 5 · 320+ reviews</span>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {reviews.map((r, i) => (
            <motion.div
              key={r.name}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="rounded-[2rem] border border-black/10 bg-white p-7 hover:-translate-y-1 transition-transform"
              data-testid={`review-${i}`}
            >
              <Quote className="text-brand-coral" size={32} />
              <p className="mt-4 text-ink/80 font-500 text-lg leading-relaxed">"{r.text}"</p>
              <div className="mt-6 pt-5 border-t border-black/10">
                <div className="font-display font-800 text-lg">{r.name}</div>
                <div className="text-sm text-ink/50 font-500">{r.event}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
